!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.ksh = t());
}(this, function () {
  "use strict";

  return [{
    locale: "ksh",
    pluralRuleFunction: function (e, t) {
      return t ? "other" : 0 == e ? "zero" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "Johr",
        relative: {
          0: "diß Johr",
          1: "näx Johr",
          "-1": "läz Johr"
        },
        relativeTime: {
          future: {
            zero: "en keinem Johr",
            one: "en {0} Johr",
            other: "en {0} Johre"
          },
          past: {
            zero: "vör keijnem Johr",
            one: "vör {0} Johr",
            other: "vör {0} Johre"
          }
        }
      },
      "year-short": {
        displayName: "J.",
        relative: {
          0: "diß Johr",
          1: "näx Johr",
          "-1": "läz Johr"
        },
        relativeTime: {
          future: {
            zero: "en keinem Johr",
            one: "en {0} Johr",
            other: "en {0} Johre"
          },
          past: {
            zero: "vör keijnem Johr",
            one: "vör {0} Johr",
            other: "vör {0} Johre"
          }
        }
      },
      month: {
        displayName: "Mohnd",
        relative: {
          0: "diese Mohnd",
          1: "nächste Mohnd",
          "-1": "lätzde Mohnd"
        },
        relativeTime: {
          future: {
            other: "+{0} m"
          },
          past: {
            other: "-{0} m"
          }
        }
      },
      "month-short": {
        displayName: "Mohnd",
        relative: {
          0: "diese Mohnd",
          1: "nächste Mohnd",
          "-1": "lätzde Mohnd"
        },
        relativeTime: {
          future: {
            other: "+{0} m"
          },
          past: {
            other: "-{0} m"
          }
        }
      },
      day: {
        displayName: "Daach",
        relative: {
          0: "hück",
          1: "morje",
          2: "övvermorje",
          "-2": "vörjestere",
          "-1": "jestere"
        },
        relativeTime: {
          future: {
            other: "+{0} d"
          },
          past: {
            other: "-{0} d"
          }
        }
      },
      "day-short": {
        displayName: "D.",
        relative: {
          0: "hück",
          1: "morje",
          2: "övvermorje",
          "-2": "vörjestere",
          "-1": "jestere"
        },
        relativeTime: {
          future: {
            other: "+{0} d"
          },
          past: {
            other: "-{0} d"
          }
        }
      },
      hour: {
        displayName: "Schtund",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "+{0} h"
          },
          past: {
            other: "-{0} h"
          }
        }
      },
      "hour-short": {
        displayName: "Std.",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "+{0} h"
          },
          past: {
            other: "-{0} h"
          }
        }
      },
      minute: {
        displayName: "Menutt",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "+{0} min"
          },
          past: {
            other: "-{0} min"
          }
        }
      },
      "minute-short": {
        displayName: "min.",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "+{0} min"
          },
          past: {
            other: "-{0} min"
          }
        }
      },
      second: {
        displayName: "Sekond",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "+{0} s"
          },
          past: {
            other: "-{0} s"
          }
        }
      },
      "second-short": {
        displayName: "sek.",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "+{0} s"
          },
          past: {
            other: "-{0} s"
          }
        }
      }
    }
  }];
});